import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { AdministrationStateModel } from './administration-state.model';
import { AdministrationState } from './administration.state';
import { TGetMailSwitchesDTO, TUserAdminplusCompanyDTO } from '@api';

@Injectable()
export class AdministrationStateSelectors {
  @Selector([AdministrationState])
  public static getUserList(
    state: AdministrationStateModel
  ): TUserAdminplusCompanyDTO[] {
    return state.userList;
  }

  @Selector([AdministrationState])
  public static isLoading(state: AdministrationStateModel): boolean {
    return state.actionState.isLoading;
  }

  @Selector([AdministrationState])
  public static isCsvDone(state: AdministrationStateModel): boolean {
    return state.actionStateUserCSV.done;
  }

  @Selector([AdministrationState])
  public static getUserDataCSV(state: AdministrationStateModel): {
    csv?: string;
    fileName?: string;
  } {
    return state.userDataCSV;
  }

  @Selector([AdministrationState])
  public static getEMailSettings(
    state: AdministrationStateModel
  ): TGetMailSwitchesDTO {
    return state.eMailSettings;
  }
}
